import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
// ui
import { Box, Span } from '../../ui';
//////////////////////////////////////////////////

const titleStyles = {
  mx: '8px',
  fontSize: 14,
  fontWeight: 'bold',
};

const errorWrapperStyles = {
  p: '3px 8px',
  fontSize: 12,
  wordBreak: 'break-all',
};

const RequestStatusModal = (props) => {
  const { errors, globalErrors, requestStatusInfo } = props;

  return (
    <Box>
      <Box p={15}>
        <Box {...titleStyles}>
          {G.getWindowLocale('titles:request-status', 'Request Status')}:
        </Box>
        <Box p='3px 8px' fontSize={12}>{requestStatusInfo}</Box>
        {
          G.isNotNilAndNotEmpty(globalErrors) &&
          <Box>
            <Box {...titleStyles} mt='8px'>
              {G.getWindowLocale('titles:global-errors', 'Global Errors')}:
            </Box>
            {
              globalErrors.map((globalError, i) => (
                <Box key={i} {...errorWrapperStyles}>
                  {globalError}
                </Box>
              ))
            }
          </Box>
        }
        {
          G.isNotNilAndNotEmpty(errors) &&
          <Box>
            <Box {...titleStyles} mt='8px'>
              {G.getWindowLocale('titles:errors', 'Errors')}:
            </Box>
            {
              errors.map(({ key, messageArray }, i) => (
                <Box key={i} {...errorWrapperStyles}>
                  <Span mr='6px' fontWeight='bold'>{key}:</Span>
                  {R.join(', ', messageArray)}
                </Box>
              ))
            }
          </Box>
        }
      </Box>
    </Box>
  );
};

export default RequestStatusModal;
